module.exports = __webpack_public_path__ + "img/daftar-dokumen-active.acf70ce9.svg";